import { serverGroupsDoc } from 'app/docLinks'
import ExternalLink from 'core/components/ExternalLink'
import { uniq } from 'ramda'
import { IVirtualMachinesSelector } from './newModel'
import { AFFINITY_POLICIES } from './server-groups/PolicyPicklist'

export default function GetDisabledTooltipForVMs({
  selected,
}: {
  selected: IVirtualMachinesSelector[]
}) {
  if (uniq(selected?.map((vm) => vm?.clusterName)).length > 1) {
    return <>{'You can only migrate VMs from the same cluster'}</>
  }

  if (selected?.some((vm) => vm?.state === 'resized')) {
    return <>{'You cannot migrate VMs in a resized state'}</>
  }

  // Do not allow bulk migration of VMs that are part of affinity or anti-affinity group
  if (
    selected.length > 1 &&
    selected.some((vm) =>
      [
        AFFINITY_POLICIES.SOFT_AFFINITY,
        AFFINITY_POLICIES.SOFT_ANTI_AFFINITY,
        AFFINITY_POLICIES.HARD_ANTI_AFFINITY,
        AFFINITY_POLICIES.HARD_AFFINITY,
      ].includes(vm?.serverGroup?.policy),
    )
  ) {
    return (
      <>
        You cannot bulk migrate virtual machines that are part of an affinity or anti-affinity group
      </>
    )
  }

  if (selected?.some((vm) => vm?.serverGroup?.policy === AFFINITY_POLICIES.HARD_AFFINITY)) {
    return (
      <>
        You cannot migrate a virtual machine that is part of a hard affinity group.{' '}
        <ExternalLink url={serverGroupsDoc} newWindow>
          More info
        </ExternalLink>
      </>
    )
  }

  return null
}

export const canMigrateVMs = (userRole: string, selected: any[]): boolean => {
  // Do not allow bulk migration of VMs that are part of affinity or anti-affinity group
  if (
    selected.length > 1 &&
    selected.some((vm) =>
      [
        AFFINITY_POLICIES.SOFT_AFFINITY,
        AFFINITY_POLICIES.SOFT_ANTI_AFFINITY,
        AFFINITY_POLICIES.HARD_ANTI_AFFINITY,
        AFFINITY_POLICIES.HARD_AFFINITY,
      ].includes(vm?.serverGroup?.policy),
    )
  ) {
    return false
  }

  return (
    userRole === 'admin' &&
    uniq(selected?.map((vm) => vm?.clusterName)).length === 1 &&
    selected.every(
      (vm) =>
        !['resized'].includes(vm?.state) &&
        vm?.serverGroup?.policy !== AFFINITY_POLICIES.HARD_AFFINITY,
    )
  )
}
